module.exports = __webpack_public_path__ + "static/media/school_lime_may25.d3117c82.csv";